<template>
  <v-card :style="backOpacity">
    <v-card-title>ファイルアップロード FileuploadForm.vue</v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-text-field
              label="ラベル名"
              v-model="returnData.label"
              required
            ></v-text-field>
          </v-col>
          <v-row>
            <v-col cols="4">
              <set-Cols
                :value="String(returnData.cols)"
                v-on:set="$set(returnData, 'cols', $event)"
              ></set-Cols>
            </v-col>
          </v-row>
        </v-row>
        {{ filetypes }}

        <v-row>
          <v-col cols="2">
            <v-checkbox
              v-model="filetypes"
              label="必須"
              value="required"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <h4>ファイルタイプ</h4>
          <v-col cols="2">
            <v-checkbox
              v-model="filetypes"
              label="画像"
              value="image"
            ></v-checkbox>
          </v-col>
          <v-col cols="2">
            <v-checkbox
              v-model="filetypes"
              label="PDF"
              value="pdf"
            ></v-checkbox>
          </v-col>
          <v-col cols="2">
            <v-checkbox
              v-model="filetypes"
              label="SVG"
              value="svg"
            ></v-checkbox>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="success"
        @click="submit"
        v-on:mouseover="backOpacity = 'opacity: 0.1'"
        v-on:mouseleave="backOpacity = 'opacity: 1'"
        x-large
        >OK</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import setCols from "./common/setCols.vue";
export default {
  components: {
    setCols,
  },
  props: {
    label: String,
    init: String,
    type: Number,
    cols: String,
    position: Number,
    size: Number,
    file_type: String,
  },
  data() {
    return {
      returnData: {
        label: this.label,
        init: this.init,
        type: this.type,
        cols: this.cols,
        position: this.position,
        size: this.size,
        file_type: this.file_type,
      },
      backOpacity: "opacity: 1",
      filetypes: ["image"],
      varidation: {
        numonly: (value) => {
          return /^[0-9]*$/.test(value) || "数値のみ";
        },
        cols: (value) => {
          return /^([0-9]|1[0-2]|auto)$/.test(value) || "0~12,autoのみ";
        },
      },
    };
  },

  mounted() {
    this.filetypes = JSON.parse(this.file_type);
  },
  methods: {
    submit() {
      if (this.filetypes.length == 0) {
        alert("最低一つファイルタイプを選んでください");
        return;
      }

      this.returnData.file_type = JSON.stringify(this.filetypes);
      this.$emit("clickSubmit", this.returnData);
    },
  },
};
</script>
